/**
 * Public URL of a store, same format as `PreviewLinkStore`:
 * `https://{domain | url.ecometri.shop}/{default_user_store.mobile_phone_number | 0}`.
 * @param {Object} store store data from `getStoreService`
 * @returns {string} the public URL, or '' when the store has no domain or url yet
 */
export const getStorePublicUrl = (store) => {
    if (!store) return '';
    const host = store.domain || (store.url ? `${store.url}.ecometri.shop` : '');
    if (!host) return '';
    const phone = store.default_user_store?.mobile_phone_number || 0;
    return `https://${host}/${phone}`;
};

/** The URL without protocol, for display. */
export const getDisplayUrl = (url) => (url || '').replace(/^https?:\/\//, '');
